import * as React from 'react';
import { Route } from 'react-router-dom';

import BackofficeTemplate from './BackofficeTemplate/BackofficeTemplate';

export const endpointMacra2 = {
    //Backoffice Macra2
    macra2BackofficeTemplate: '/backoffice/grade-control-structures/template',
    macra2BackofficeTemplateWithId: '/backoffice/grade-control-structures/template/:id',
    macra2BackofficeTemplateWithType: '/backoffice/grade-control-structures/template/type/:type',
};

const routesMacra2 = () => (
    <>
        <Route path={endpointMacra2.macra2BackofficeTemplate} element={<BackofficeTemplate />} />
        <Route path={endpointMacra2.macra2BackofficeTemplateWithId} element={<BackofficeTemplate />} />
        <Route path={endpointMacra2.macra2BackofficeTemplateWithType} element={<BackofficeTemplate />} />
    </>
);

export default routesMacra2();
